<template>
    <design-2021-apprentice-data-table
        :items="groups"
        :fields="fields">
        <template v-slot:cell(actions)="data">
            <b-form-checkbox
                :checked="!!data.item.digistudies_access"
                @change="updateAccess(data.item, $event)"
                switch>
            </b-form-checkbox>
        </template>
    </design-2021-apprentice-data-table>
</template>

<script>
export default {
    name: 'design-2021-school-settings-digistudies-access-groups-table-component',
    props: ['groupsIn', 'type'],
    data() {
        return {
            groups: this.groupsIn,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                },
            ],
        };
    },
    methods: {
        updateAccess(group, value) {
            if (value) {
                if (this.type === 'group') {
                    this.axios.post(this.routes.digistudiesGroupStore(group.id)).then(
                        (response) => {
                            this.groups = this.groups.map((g) => {
                                if (g.id === group.id) {
                                    g.digistudies_access = response.data;
                                }
                                return g;
                            });
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }

                if (this.type === 'lasGroup') {
                    this.axios.post(this.routes.digistudiesLasGroupStore(group.id)).then(
                        (response) => {
                            this.groups = this.groups.map((g) => {
                                if (g.id === group.id) {
                                    g.digistudies_access = response.data;
                                }
                                return g;
                            });
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }

                if (this.type === 'lasMainGroup') {
                    this.axios.post(this.routes.digistudiesLasMainGroupStore(group.id)).then(
                        (response) => {
                            this.groups = this.groups.map((g) => {
                                if (g.id === group.id) {
                                    g.digistudies_access = response.data;
                                }
                                return g;
                            });
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }
            } else {
                if (this.type === 'group') {
                    this.axios.delete(this.routes.digistudiesGroupDestroy(group.id, group.digistudies_access.id)).then(
                        (response) => {
                            this.groups = this.groups.map((g) => {
                                if (g.id === group.id) {
                                    g.digistudies_access = null;
                                }
                                return g;
                            });
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }

                if (this.type === 'lasGroup') {
                    this.axios
                        .delete(this.routes.digistudiesLasGroupDestroy(group.id, group.digistudies_access.id))
                        .then(
                            (response) => {
                                this.groups = this.groups.map((g) => {
                                    if (g.id === group.id) {
                                        g.digistudies_access = null;
                                    }
                                    return g;
                                });
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                }

                if (this.type === 'lasMainGroup') {
                    this.axios
                        .delete(this.routes.digistudiesLasMainGroupDestroy(group.id, group.digistudies_access.id))
                        .then(
                            (response) => {
                                this.groups = this.groups.map((g) => {
                                    if (g.id === group.id) {
                                        g.digistudies_access = null;
                                    }
                                    return g;
                                });
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                }
            }
        },
    },
};
</script>

<style scoped></style>
